<template>
  <div class="text-item-content">
    <div class="text-title">{{title}}</div>
    <div class="text-content">{{datamodel.value}}</div>
  </div>
</template>

<script>

export default {
  uuid: "00000000-0000-0000-0000-000000000002",
  components: {},
  props: [
    'datamodel',
  ],
  data() {
    return {
      
    }
  },
  computed: {
    title() {
      if(this.$i18n.locale == 'zh-CN'){
        return this.datamodel.zhlabel  
      }
      return this.datamodel.enlabel
    }
  },
  methods: {
    
  },
  created() {},
  mounted() {

  }
}
</script>
<style lang="scss" scoped>
.text-item-content {
    flex-direction: column;
    .text-title {
        width: 100%;
        padding: 10px 0;
        word-wrap: break-word;
        word-break: keep-all;
        // word-break: break-word;
    }
    .text-content {
        width: 100%;
        padding: 10px 0;
        padding-top: 0px;
    }
}

</style>
